import apiHandler from "../core/apiHandler";

const cashDrawerApi = apiHandler('cash-drawers');
export default cashDrawerApi;